import images from "../../../Assets/Images/Image/Why choose Us.webp";
import icon1 from "../../../Assets/Images/Image/Icon (5).png";
import icon2 from "../../../Assets/Images/Image/Icon (6).png";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";

const WhyChooseUs = () => {
  return (
    <Fade bottom>
      <section className="2xl:max-w-[1320px]  mt-[100px] mb-[130px] px-10 max-xl:px-0 flex flex-col max-lg:flex-row justify-between items-center  max-xl:max-w-[1150px]  gap-20 mx-auto">
        <div className=" max-lg:w-[55%] order-2 max-lg:order-1	">
          <button className="custom_button2">
            <span>Why choose Us? ~</span>
          </button>

          <h2 className="text-[#0D1C37] text-2xl max-md:text-[42px] leading-[53px] capitalize font-black mb-[19px]">
            Providing <span className="text-linear-gradient"> best</span>{" "}
            Quality freelancing courses and all IT
            <span className="text-linear-gradient"> Solutions</span>
          </h2>
          <p className="text-[#6A6D7A] text-lg text-justify leading-8">
            In the dynamic world of freelancing, entrepreneurship, and digital
            innovation, WebNex-IT stands as a beacon of empowerment. At the
            heart of our mission is a commitment to unlocking the full potential
            of individuals and businesses through cutting-edge courses, bespoke
            website design, and development services.
          </p>
          <div className="flex mt-8 flex-col max-sm:flex-row gap-5 items-center">
            <div className="flex gap-5">
              <img src={icon1} className="w-[68px] h-[68px]" alt="IT Ghar" />
              <div>
                <h3
                  className="text-[#0D1C37] font-bold text-xl mb-3"
                  title="At WebNex-IT, our mission is clear: to provide unparalleled learning experiences and services that propel freelancers, entrepreneurs, and businesses towards unprecedented success. We believe in fostering a culture of continuous growth, enabling our clients to thrive in the ever-evolving digital landscape."
                >
                  Company Mission
                </h3>
                <p
                  className="text-[15px] text-[#6A6D7A]"
                  title="At WebNex-IT, our mission is clear: to provide unparalleled learning experiences and services that propel freelancers, entrepreneurs, and businesses towards unprecedented success. We believe in fostering a culture of continuous growth, enabling our clients to thrive in the ever-evolving digital landscape."
                >
                  Nurturing Excellence, One Skill at a Time
                </p>
              </div>
            </div>
            <div className="flex   gap-5">
              <img src={icon2} className="w-[68px] h-[68px]" alt="IT Ghar" />
              <div>
                <h3
                  className="text-[#0D1C37] font-bold text-xl mb-3"
                  title="Our vision is to be a catalyst for positive change in the online and offline realms. We aspire to be the go-to platform for those seeking not just education and services but a transformative journey towards realizing their dreams. WebNex-IT envisions a future where every individual and business can harness the power of the digital world with confidence and expertise."
                >
                  Company Vision
                </h3>
                <p
                  className="text-[15px] text-[#6A6D7A]"
                  title="Our vision is to be a catalyst for positive change in the online and offline realms. We aspire to be the go-to platform for those seeking not just education and services but a transformative journey towards realizing their dreams. WebNex-IT envisions a future where every individual and business can harness the power of the digital world with confidence and expertise."
                >
                  Shaping Futures, Transforming Visions into Reality
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8 ">
            <Link to="/about">
              <button className="custom_button ">
                {" "}
                More About Us
                <i className="fa-solid fa-arrow-right ml-2"></i>
              </button>
            </Link>
          </div>
        </div>
        <div className=" max-lg:w-[45%] order-1 max-lg:order-2	">
          <img src={images} alt="IT Ghar" />
        </div>
      </section>
    </Fade>
  );
};

export default WhyChooseUs;
